import Vue from 'vue'
import mutations from './mutations'
import clientsCertificates from '@/api/clientsCertificates'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {},
    certificateWarning: []
  },

  actions: {
    loadItems ({ commit }, { childCompanyId }) {
      return new Promise((resolve, reject) => {
        clientsCertificates.getAll({ childCompanyId })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadItem ({ commit }, { childCompanyId, certificateId }) {
      return new Promise((resolve, reject) => {
        clientsCertificates.getById({ childCompanyId, certificateId })
          .then(response => {
            const item = response.data.items[0]
            commit('setElement', { type: 'items', certificateId, element: item })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    saveItem ({ commit }, { childCompanyId, item }) {
      return new Promise((resolve, reject) => {
        clientsCertificates.save({ childCompanyId, item })
          .then(response => {
            const itemId = response.data.items[0].id
            commit('setElement', { type: 'items', id: itemId, element: { id: itemId, ...item } })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    deleteItem ({ commit, state }, { childCompanyId, certificateId }) {
      return new Promise((resolve, reject) => {
        clientsCertificates.delete({ childCompanyId, certificateId })
          .then(response => {
            commit('removeElement', { type: 'items', id: certificateId })
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    setActive ({ commit, state }, { childCompanyId, certificateId, active }) {
      return new Promise((resolve, reject) => {
        clientsCertificates.setActive({ childCompanyId, certificateId, active })
          .then(response => {
            const oldItem = state.items[certificateId]
            const newItem = { ...oldItem, is_active: active }
            commit('setElement', { type: 'items', id: certificateId, element: newItem })
            resolve(newItem)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    async getCertificateWarnings ({ commit, state }) {
      const certificateWarning = await clientsCertificates.getCertificateWarnings()
      if (certificateWarning) {
        commit('setCertificateWarning', certificateWarning.data.items)
        return certificateWarning
      }
    }
  },

  mutations: {
    ...mutations,
    setCertificateWarning (state, certificate) {
      Vue.set(state, 'certificateWarning', certificate)
    }
  }
}
